const isTest = process.env.NODE_ENV === "test";

export class Logger {
  static get debug() {
    return isTest
      ? () => {
          /* do nothing */
        }
      : console.debug.bind(window.console);
  }

  static get log() {
    return isTest
      ? () => {
          /* do nothing */
        }
      : console.log.bind(window.console);
  }

  static get warn() {
    return isTest
      ? () => {
          /* do nothing */
        }
      : console.warn.bind(window.console);
  }

  static get error() {
    return isTest
      ? () => {
          /* do nothing */
        }
      : console.error.bind(window.console);
  }
}
